
const white = '#FFFFFF';
const black = '#000000';

export default {
  black,
  white,
  primary: {
    contrastText: white,
    dark: '#3B99EB',
    main:'#3B99EB',
    light: '#3B99EB'
  },
  secondary:{
    contrastText: white,
    main:'#70bf4e',
    dark: '#70bf4e',
    light: '#70bf4e'
  },
  primary2:{
    contrastText: white,
    main:'#FF9800',
    dark: '#FF9800',
    light: '#FF9800'
  }
};
